import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LinktreePage from './pages/LinktreePage';
import RegisterPage from './pages/RegisterPage';
import PortalPage from './pages/PortalPage';
import PassportPage from './pages/PassportPage';
import RedeemPage from './pages/RedeemPage';
import CorporatePage from './pages/CorporatePage';
import FnbPage from './pages/FnbPage';
import MemoriesMarketPage from './pages/MemoriesMarketPage';
import DashboardLogin from './pages/DashboardLogin';
import DashboardPage from './pages/DashboardPage';
import ShortRedirect from './pages/ShortRedirect';
import PixelInjector from './components/PixelInjector';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PixelInjector />
        <Toaster />
        <Routes>
          <Route path="/" element={<MemoriesMarketPage />} />
          <Route path="/home" element={<LinktreePage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/portal/:token" element={<PortalPage />} />
          <Route path="/passport" element={<PassportPage />} />
          <Route path="/redeem" element={<RedeemPage />} />
          <Route path="/corporate" element={<CorporatePage />} />
          <Route path="/fnb" element={<FnbPage />} />
          <Route path="/memories" element={<MemoriesMarketPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/login" element={<DashboardLogin />} />
          <Route path="/s/:slug" element={<ShortRedirect />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
